import { ProductContractItem } from '@/ContractConfig';

export enum ContractEnum {
  REGISTER = 'full.product.3.reg', // 第三方注册合同
  LOAN = 'full.product.3.loan', // 第三方借款合同

  PREAPPLY = 'full.product.3.reg', // 授信，与前面注册一致
  APPLY = 'full.product.3.loan', // 提现时，与前面借款一致
  Bill = 'full.product.3.repay', // 还款账单页面合同
  BIND = 'full.product.3.bind', // 绑卡
  PSW = 'full.product.3.pwd', // 输入密码时
  OFFICAL_LOAN_CONTRACT = 'full.product.bill.loan', // 账单页面显示正式借款合同，三方正式合同，而不是模版
  ZY_PREAPPLY = 'full.product.3.agree;full.product.3.reg', // 中邮渠道获取授信合同展示
  APPLY_NEW_CONTRACT = 'full.product.3.loan.add', // 交易鉴权之后获取合同
  DXM_APPLY_CONTRACT = 'full.product.3.loan.2.add' // 度小满二次交易交易鉴权合同
}

export const ContractEnumToContractType: Dictionary<
  keyof ProductContractItem | undefined
> = {
  [ContractEnum.REGISTER]: 'preApplyContracts',
  [ContractEnum.PREAPPLY]: 'preApplyContracts',
  [ContractEnum.LOAN]: 'applyContracts',
  [ContractEnum.APPLY]: 'applyContracts',
  [ContractEnum.PSW]: 'pwdContracts',
  [ContractEnum.BIND]: 'bindContracts',
  [ContractEnum.OFFICAL_LOAN_CONTRACT]: 'officalApplyContracts',
  [ContractEnum.Bill]: undefined,
};

/** 当前合同的文件类型 */
export enum ContractFileType {
  /** pdf 需要特殊处理，需要标记 */
  PDF = 'pdf',
  /** 普通文件类型 */
  NORMAL = 'normal'
}


/** 贷超拦截禁止微信唤端 开关枚举值 */
export enum SwitchTypeEnum {
  /** 开启 */
  ON = 1,
  /** 关闭 */
  OFF = 0,
}
